import { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Checkbox from "@mui/material/Checkbox";
import {
  addCredentialsManagementShareSelectedUser,
  removeCredentialsManagementShareSelectedUser
} from "redux/actions/portal/credentialManagementActionCreator";

const CheckboxShareTo = ({ value }) => {
  const dispatch = useDispatch();
  const { credentialManangementShareSelectedUsers } = useSelector(
    (store) => store.portal.credentialManagement
  );

  const handleSelectUser = (e, userId) => {
    const { checked } = e.target;

    if (checked) {
      dispatch(addCredentialsManagementShareSelectedUser({ user_id: userId, share_type: "use" }));
    } else {
      dispatch(removeCredentialsManagementShareSelectedUser(userId));
    }
  };
  return (
    <Checkbox
      checked={credentialManangementShareSelectedUsers.some((user) => user?.user_id === value)}
      onChange={(e) => handleSelectUser(e, value)}
    />
  );
};

export default memo(CheckboxShareTo);
